import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LoadingImage from '../Images/loading.gif';
import ErrorPage from './Errorpage';

const ADTDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  
  useEffect(() => {
    try {
      window.history.pushState("you are being redirected...", "Redirect", "/redirect");
    } catch (err) {
      if (typeof console !== 'undefined') console.log(err);
    }
    
    const queryParams = new URLSearchParams(location.search);
    const caeQMemID = queryParams.get('memqnxtid');
    const systemId = queryParams.get('SystemId');
    const userId = queryParams.get('UserId');
    const Module = queryParams.get('module') || '';
    
    fetchADTDashboardURL(caeQMemID, systemId, userId, Module);
  }, [location]);
  
  const fetchADTDashboardURL = async (caeQMemID, systemId, userId, Module) => {
    try {
      const response = await axios.get(`${API_URL}/api/ADTDashboard/LoadDashboard`, {
        params: {
          caeQMemID: caeQMemID || '',
          systemId: systemId || '',
          userId: userId || '',
          Module: Module || 'ADTDashboard'
        }
      });

      setLoading(false);
      
      // Use direct navigation instead of form submission
      if (response.data && (response.data.redirectUrl || response.data.url)) {
        const navigationUrl = response.data.redirectUrl || response.data.url;
        window.location.href = navigationUrl;
      } else {
        setError('adtd'); 
       
      }
    } catch (error) {
      console.error('Error fetching ADT dashboard URL:', error);
      setError('adtd'); 
      setLoading(false);
    }
  };

  return (
    <div>
      <table style={{backgroundColor: 'transparent'}} cellPadding="0" cellSpacing="0">
        <tbody>
          <tr>
            <td style={{width: '30%'}}></td>
            <td align="center" style={{fontSize: 'x-large'}}>
              {error && <ErrorPage errorType="adtd" />}
            </td>
            <td style={{width: '30%'}}></td>
          </tr>
          <tr>
            <td style={{width: '50%'}}></td>
            <td align="center" style={{fontSize: 'large'}}>
              {loading && (
                <div>
                  <div style={{float: 'left'}}>
                    <img src={LoadingImage} id="loadinggif" alt="Loading" />
                  </div>
                  <div style={{float: 'left'}} id="loadingtext">
                    Loading...
                  </div>
                </div>
              )}
            </td>
            <td style={{width: '50%'}}></td>
          </tr>
          <tr>
            <td style={{width: '50%'}}></td>
            <td align="center" style={{fontSize: 'large'}}>
              <div id="divTest"></div>
            </td>
            <td style={{width: '50%'}}></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ADTDashboard;

